<ix-modal-header>{{
  'dpp.modal_create_submodel.title' | translate
}}</ix-modal-header>
<ix-modal-content>
  <div class="d-flex flex-row align-items-center my-3">
    <ix-typography format="display-xs" id="selectSubmodelLabel">
      {{ 'dpp.modal_create_submodel.select_submodel' | translate }}
    </ix-typography>
    <ix-icon
      aria-describedby="submodel-info-tooltip"
      id="submodel-info-icon"
      name="info"
      size="16"
      class="ms-1"
    ></ix-icon>
    <ix-tooltip for="#submodel-info-icon" id="submodel-info-tooltip">
      {{ 'dpp.modal_create_submodel.already_exists_info' | translate }}
    </ix-tooltip>
  </div>
  <div class="d-flex workflow-selector gap-3">
    @for (type of allSubmodels; track type; let i = $index) {
      <ix-card
        [id]="'submodel-card-' + i"
        [class]="'submodel-card' + (isDisabled(type) ? ' disabled' : '')"
        [selected]="selectedSubmodel === type"
        (click)="selectSubmodel(type)"
        onkeypress=""
      >
        <div
          [class]="
            'w-100 overflow-hidden small-card-background ' +
            getSubmodelImageClass(type)
          "
        ></div>
        <ix-card-content>
          <ix-icon
            [name]="getSubmodelIcon(type)"
            size="24"
            class="submodel-card-icon"
          ></ix-icon>
          <ix-typography [bold]="true" format="display-xs">
            {{ type | translate }}
          </ix-typography>
        </ix-card-content>
      </ix-card>
    }
  </div>
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    variant="secondary"
    class="dismiss-modal"
    id="cancelButton"
    (click)="onCancel()"
    onkeypress=""
  >
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    class="dismiss-modal"
    id="addButton"
    [disabled]="isAddButtonDisabled()"
    (click)="onAdd()"
    onkeypress=""
  >
    {{ 'general.add' | translate }}
  </ix-button>
</ix-modal-footer>
